<script setup lang="ts">
import { ArrowRightIcon, CheckIcon, ClockIcon } from 'lucide-vue-next'
import { computed } from 'vue'

const {
  value = 0,
  translationKey,
  disabled = false,
} = defineProps<Props>()

const { t } = useI18n()
const router = useRouter()

interface TranslatedData {
  title: string
  content: string
  buttonLabel: string
  to: string
}

interface Props {
  done: boolean
  translationKey: string
  value?: number | string
  disabled?: boolean
}

const translatedData = computed((): TranslatedData => {
  return {
    title: t(`${translationKey}.title`),
    content: t(`${translationKey}.content`),
    buttonLabel: t(`${translationKey}.buttonLabel`),
    to: t(`${translationKey}.to`),
  }
})
</script>

<template>
  <div class="card bg-primary text-primary-content">
    <div class="card-body">
      <div class="card-title">
        <h2 :class="{ 'line-through': done }" class="text-2xl font-bold">
          <slot name="title">
            {{ translatedData.title }}
          </slot>
        </h2>
      </div>

      <div class="flex">
        <div class="w-2/3">
          <p class="text-primary-content/80">
            {{ translatedData.content }}
          </p>
        </div>

        <slot name="rightContent">
          <div class="ml-auto">
            <span v-if="done" class="badge badge-sm gap-1 whitespace-nowrap">
              <CheckIcon :size="16" />
              {{ t('first_steps.done') }}
            </span>
            <span v-else-if="!done && Number(value) === 0" class="badge badge-sm badge-warning gap-1 whitespace-nowrap">
              <ArrowRightIcon :size="16" />
              <span>{{ t('first_steps.todo', { minutes: 5 }) }}</span>
            </span>
            <span v-else class="badge badge-sm gap-1 whitespace-nowrap">
              <ClockIcon :size="16" />
              {{ t('first_steps.in_progress') }}
            </span>
          </div>
        </slot>
      </div>

      <div class="card-actions pt-4">
        <Tooltip :text="disabled ? t('global.coming_soon') : ''">
          <EButton
            :disabled="disabled"
            class="btn-secondary"
            @click="router.push(translatedData.to)"
          >
            {{ translatedData.buttonLabel }}
          </EButton>
        </Tooltip>
      </div>
    </div>
  </div>
</template>
